import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PrivateRoute = ({ component: Component, requireAdminOrQa = false, ...rest }) => {
    const auth = useSelector(state => state.authentication);
    const isAuthenticated = !!auth?.isAuthenticated || !!localStorage.getItem('auth');
    const isAdminOrQa = !!auth?.user?.is_admin_or_qa;

    return (
        <Route
            {...rest}
            render={props => {
                if (!isAuthenticated) {
                    return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
                }
                if (requireAdminOrQa && !isAdminOrQa) {
                    // Not authorized for this route
                    return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
                }
                return <Component {...props} />;
            }}
        />
    );
};